import React, { PureComponent } from 'react';
import { Table } from 'reactstrap';
import { decorators, DataRow } from '@orange-marmalade/paginate-this';

// components
import DesignationResult from './DesignationResult';

// modules
import BS from '../../theme/Bootstrap';

class DesignationSearchResults extends PureComponent {
  render() {
    const { ids, className, isLoading } = this.props;

    return (
      <div>
        <Table className={className}>
          <tbody>
            {ids.map((id, i) => {
              return (
                <DataRow key={id} itemId={id} component={DesignationResult} index={i} />
              );
            })}
            {ids.length === 0 && !isLoading && (
              <tr className={`${BS.mb3} ${BS.textCenter}`}>
                <td>No Results</td>
              </tr>
            )}
          </tbody>
        </Table>
        {isLoading && <div className={BS.loadingMask}>LOADING</div>}
      </div>
    );
  }
}

export default decorators.tabulateLean(DesignationSearchResults);



// WEBPACK FOOTER //
// ./src/containers/DesignationSearch/DesignationSearchResults.js